import React from "react";
import { getRiotAssetsContext } from "@outplayed/riot-assets";
import { ChampionSkill } from "@outplayed/tooltips";

const AdditionalStats = (props) => {
  const { championName, queueTypeName, championId, championModifications, championData } = props;

  const { getChampionSkillNames, getChampionPassiveJSON } = getRiotAssetsContext();

  if (!championModifications) {
    return null;
  }

  const filterStats = (targetChampStats) => {
    let allStats = [];
    let entireChange, difference, amountChanged;
    for (let [key, value] of Object.entries(targetChampStats)) {
      entireChange = null;
      if (value !== 1) {
        if (key != "abilities") {
          amountChanged = value;
          value =
            amountChanged - 1 > 0
              ? "+" + Math.round((value - 1) * 100).toString() + "%"
              : "-" + Math.round((value - 1) * -100).toString() + "%";
          difference = amountChanged - 1 > 0 ? "increased by " : "decreased by ";
        }
        if (key === "damage_taken") {
          entireChange = (
            <>
              <p className="bold-right">{value}</p> Damage taken
            </>
          );
        } else if (key === "damage_dealt") {
          entireChange = (
            <>
              <p className="bold-right">{value}</p> Damage dealt
            </>
          );
        } else if (key === "damage_healing") {
          entireChange = (
            <>
              {"Healing done " + difference}
              <p className="bold-left">{value}</p>
            </>
          );
        } else if (key === "damage_shielding") {
          entireChange = (
            <>
              {"Shielding done " + difference}
              <p className="bold-left">{value}</p>
            </>
          );
        } else if (key === "abilities") {
          for (const [subkey, subvalue] of Object.entries(value)) {
            const stats = subvalue.split("\n");
            if (subkey === "Stats") {
              for (const stat in stats) {
                allStats.push(
                  <>
                    <div className="bullet" />
                    <p>{stats[stat]}</p>
                  </>,
                );
              }
            } else {
              const image = getImageFromName(subkey.trim(), championId);
              allStats.push(
                <div className="ability">
                  <a className="title">
                    {image} {subkey}
                  </a>
                  <ul className="description">
                    {stats.map((stat, idx) => (
                      <p className="bullets" key={idx}>
                        {stat}
                      </p>
                    ))}
                  </ul>
                </div>,
              );
            }
          }
        }
        if (entireChange != null) {
          allStats.push(
            <>
              <div className="bullet" />
              {entireChange}
            </>,
          );
        }
      }
    }
    return allStats;
  };

  const getImageFromName = (target, championId) => {
    for (const [idx, ability] of getChampionSkillNames(championId, { optionalData: championData }).entries()) {
      if (ability.trim() === target) {
        return <ChampionSkill className="image" championId={championId} skillSlot={idx} ssr isPassive={false} />;
      }
    }
    const passive = getChampionPassiveJSON(championId, { optionalData: championData });
    if (passive && passive.name.trim() === target) {
      return <ChampionSkill className="image" championId={championId} ssr isPassive={true} />;
    }
  };

  const getLolWikiURL = (queueTypeName) => {
    return queueTypeName === "ARURF" || queueTypeName === "URF"
      ? "https://leagueoflegends.fandom.com/wiki/Ultra_Rapid_Fire"
      : "https://leagueoflegends.fandom.com/wiki/ARAM";
  };

  const finalModifications = filterStats(championModifications);
  return (
    <div className="additional-stats">
      <div className="header-container">
        <div className="blue-bar" />
        <h1 className="header">
          {championName} {queueTypeName} Modifications
        </h1>
      </div>
      <div className="main-content">
        <ul className="list">
          {finalModifications.map((modification, idx) => {
            return (
              <div className="entireChange" key={idx}>
                {modification}
              </div>
            );
          })}
          <li className="remark">
            Stats collected from{" "}
            <a target="_blank" className="link" href={getLolWikiURL(queueTypeName)}>
              here
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default AdditionalStats;
